export default __webpack_public_path__ + "static/media/why9.cf5aa1ad.png";